// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { FaUsers, FaUser, FaDashcube, FaRegUser } from "react-icons/fa"; // Import user-related icons
// import { FaUserDoctor } from "react-icons/fa6";
// import { IoIosNotifications } from "react-icons/io";
// import { RiQuestionAnswerFill } from "react-icons/ri";
// import { TbLogs } from "react-icons/tb";

// const links = [
//   { to: "/home", label: "Dashboard", icon: <FaDashcube /> },
//   {
//     label: "Users",
//     icon: <FaRegUser />,
//     submenu: [
//       { to: "/therapist", label: "Therapists", icon: <FaUserDoctor /> },
//       { to: "/patient", label: "Clients", icon: <FaUser /> },
//     ],
//   },
//   {
//     to: "/doc-appointment",
//     label: "Appointment",
//     icon: <RiQuestionAnswerFill />,
//   },
//   { to: "/notification", label: "Notification", icon: <IoIosNotifications /> },
//   { to: "/questionnaire", label: "Questionnare", icon: <TbLogs /> },
//   { to: "/blogs", label: "Blogs", icon: <TbLogs /> },
//   { to: "/webinars", label: "Webinars", icon: <TbLogs /> },
//   {
//     to: "/sportpsychologytrainings",
//     label: "Sport Psychology Training",
//     icon: <TbLogs />,
//   },
//   { to: "/stores", label: "Stores", icon: <TbLogs /> },
//   { to: "/legals", label: "Legals", icon: <TbLogs /> },
//   { to: "/inthenews", label: "In The News", icon: <TbLogs /> },
//   { to: "/faq", label: "FAQ", icon: <TbLogs /> },
//   { to: "/podcast", label: "Podcasts", icon: <TbLogs /> },
// ];

// const Sidebar = ({ isCollapsed }) => {
//   const [openMenus, setOpenMenus] = useState({});
//   const location = useLocation();

//   const handleMenuToggle = (label) => {
//     setOpenMenus((prevState) => ({
//       ...prevState,
//       [label]: !prevState[label],
//     }));
//   };

//   const isSubmenuActive = (submenu) => {
//     return submenu.some((subLink) => location.pathname === subLink.to);
//   };

//   return (
//     <div
//     className={`sidebar  text-white transition-all duration-300 ease-in-out w-64 h-screen bg-[#1c2434] overflow-y-auto pt-0  fixed top-0 left-0 shadow-lg left-sider-bar z-[99] ${
//       isCollapsed ? 'w-[12%]' : 'w-[20%]'
//     }`}
//   >
//       <div className="logo-box mb-4 mt-3">
//         <img
//           src="./therapist-logo.png"
//           alt="therapist-logo"
//           className="max-h-[100px] object-contain w-full object-[50%_50%]"
//         />
//       </div>
//       {links.map((link, index) => {
//         const isSubmenu = Array.isArray(link.submenu);
//         const isOpen = openMenus[link.label] || false;
//         const isActive = location.pathname === link.to;
//         const isUsersActive = isSubmenu && isSubmenuActive(link.submenu);

//         return (
//           <React.Fragment key={index}>
//             {isSubmenu ? (
//               <>
//                 <div
//                   className={`flex items-center cursor-pointer p-3  ${
//                     isUsersActive
//                       ? "bg-gray-600 text-white font-bold"
//                       : "text-gray-300"
//                   }`}
//                   onClick={() => handleMenuToggle(link.label)}
//                 >
//                   {link.icon && <span className="mr-2">{link.icon}</span>}
//                   {link.label}
//                 </div>
//                 <div className={`ml-6 flex-col ${isOpen ? "flex" : "hidden"}`}>
//                   {link.submenu.map((subLink, subIndex) => {
//                     const isSubmenuActive = location.pathname === subLink.to;

//                     return (
//                       <Link
//                         key={subIndex}
//                         className={`flex items-center p-3 rounded-md ${
//                           isSubmenuActive
//                             ? "bg-gray-600 text-white font-semibold"
//                             : "text-gray-400 hover:bg-gray-600"
//                         }`}
//                         to={subLink.to}
//                       >
//                         {subLink.icon && (
//                           <span className="mr-2">{subLink.icon}</span>
//                         )}
//                         {subLink.label}
//                       </Link>
//                     );
//                   })}
//                 </div>
//               </>
//             ) : (
//               <Link
//                 className={`flex items-center p-3 mb-2 rounded-md ${
//                   isActive
//                     ? ":bg-gray-600 text-white font-bold"
//                     : "text-gray-300 hover:bg-gray-600"
//                 }`}
//                 to={link.to}
//               >
//                 {link.icon && <span className="mr-2">{link.icon}</span>}
//                 {link.label}
//               </Link>
//             )}
//           </React.Fragment>
//         );
//       })}
//     </div>
//   );
// };

// export default Sidebar;

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaUsers, FaUser, FaDashcube, FaRegUser } from "react-icons/fa";
import { FaUserDoctor } from "react-icons/fa6";
import { IoIosNotifications } from "react-icons/io";
import { RiQuestionAnswerFill } from "react-icons/ri";
import { TbLogs } from "react-icons/tb";

const links = [
  { to: "/home", label: "Dashboard", icon: <FaDashcube /> },
  {
    label: "Users",
    icon: <FaRegUser />,
    submenu: [
      { to: "/therapist", label: "Therapists", icon: <FaUserDoctor /> },
      { to: "/patient", label: "Clients", icon: <FaUser /> },
    ],
  },
  { to: "/doc-appointment", label: "Appointment", icon: <RiQuestionAnswerFill /> },
  { to: "/notification", label: "Notification", icon: <IoIosNotifications /> },
  { to: "/questionnaire", label: "Questionnaire", icon: <TbLogs /> },
  { to: "/blogs", label: "Blogs", icon: <TbLogs /> },
  { to: "/webinars", label: "Webinars", icon: <TbLogs /> },
  { to: "/sportpsychologytrainings", label: "Sport Psychology Training", icon: <TbLogs /> },
  { to: "/stores", label: "Stores", icon: <TbLogs /> },
  { to: "/legals", label: "Legals", icon: <TbLogs /> },
  { to: "/inthenews", label: "In The News", icon: <TbLogs /> },
  { to: "/faq", label: "FAQ", icon: <TbLogs /> },
  { to: "/podcast", label: "Podcasts", icon: <TbLogs /> },
];

const Sidebar = ({ isCollapsed }) => {
  const [openMenus, setOpenMenus] = useState({});
  const location = useLocation();

  const handleMenuToggle = (label) => {
    setOpenMenus((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  const isSubmenuActive = (submenu) =>
    submenu.some((sublink) => location.pathname === sublink.to);

  return (
<div
  className={`sidebar text-white transition-all duration-300 ease-in-out h-screen custom-scrollbar bg-[#1c2434] overflow-y-auto fixed overflow-x-hidden top-0 left-0 shadow-lg z-[99] ${
    isCollapsed ? "w-[6%]" : "w-[16%]"
  }`}
>



<div className={`logo-box mt-3 px-4 ${isCollapsed ? 'mb-3' : 'mb-4'}`}>
  <img
    src="./therapist-logo.png"
    alt="therapist-logo"
    className="max-h-[100px] object-contain w-full object-center"
  />
</div>


      {links.map((link, index) => {
        const isSubmenu = Array.isArray(link.submenu);
        const isOpen = openMenus[link.label] || false;
        const isActive = location.pathname === link.to;
        const isUsersActive = isSubmenu && isSubmenuActive(link.submenu);

        const iconSizeClass = isCollapsed ? "text-2xl" : "text-base";

        return (
          <React.Fragment key={index}>
            {isSubmenu ? (
              <>
                <div
                  className={`flex items-center cursor-pointer p-3 rounded-md transition-all ${
                    isCollapsed ? "justify-center" : "justify-start"
                  } ${isUsersActive ? "bg-gray-600 text-white font-bold" : "text-gray-300 hover:bg-gray-600"}`}
                  onClick={() => handleMenuToggle(link.label)}
                >
                  <span className={`min-w-[20px] ${iconSizeClass}`}>
                    {link.icon}
                  </span>
                  {!isCollapsed && <span className="ml-2">{link.label}</span>}
                </div>

                <div className={`ml-6 flex-col ${isOpen ? "flex" : "hidden"}`}>
                  {link.submenu.map((subLink, subIndex) => {
                    const isSubActive = location.pathname === subLink.to;
                    return (
                      <Link
                        key={subIndex}
                        className={`flex items-center p-3 rounded-md transition-all ${
                          isCollapsed ? "justify-center" : "justify-start"
                        } ${isSubActive ? "bg-gray-600 text-white font-semibold" : "text-gray-400 hover:bg-gray-600"}`}
                        to={subLink.to}
                      >
                        <span className={`min-w-[20px] ${iconSizeClass}`}>
                          {subLink.icon}
                        </span>
                        {!isCollapsed && (
                          <span className="ml-2">{subLink.label}</span>
                        )}
                      </Link>
                    );
                  })}
                </div>
              </>
            ) : (
              <Link
                className={`flex items-center p-3 mb-2 rounded-md transition-all ${
                  isCollapsed ? "justify-center" : "justify-start"
                } ${isActive ? "bg-gray-600 text-white font-bold" : "text-gray-300 hover:bg-gray-600"}`}
                to={link.to}
              >
                <span className={`min-w-[20px] ${iconSizeClass}`}>
                  {link.icon}
                </span>
                {!isCollapsed && <span className="ml-2">{link.label}</span>}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Sidebar;

